import { ImageType } from '../system';

export const asOptimized = (key: string) => prependBaseKey(key, ImageType.optimized);

const prependBaseKey = (key: string, imageType: string) => {
  const keyParts = key.split('/');
  const baseKey = keyParts.pop() ?? '';
  return `${keyParts.join('/')}/${imageType}-${baseKey}`;
};
